module.exports = __webpack_public_path__ + "img/home.25b6bcad.png";